import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c24c36c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "nav_left" };
const _hoisted_2 = /*#__PURE__*/ _createTextVNode(" 禁止挖矿，一经发现后自动删除相关实例，自行承担法律责任。 ");
const _hoisted_3 = { class: "home-box m-l-auto display-flex align-items" };
const _hoisted_4 = { class: "message-box" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "账号余额：", -1));
const _hoisted_6 = { class: "text" };
import CloudInfo from "@/components/CloudInfo/index.vue";
import CloudNotify from "@/components/CloudNotify/index.vue";
import { useRouterGroup } from "@/hooks/useRouterGroup";
import Area from "@/pages/Area/index.vue";
import { notReadMessage } from "@/service/message";
import { appCounterStore } from "@/store/app";
import { useCounterStore } from "@/store/user";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import PageHeader from "./Page-Header/index.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'Navbar',
    setup(__props) {
        const { activeRouterName } = useRouterGroup();
        const router = useRouter();
        const route = useRoute();
        const userStore = useCounterStore();
        const appStore = appCounterStore();
        const userInfo = userStore.getUserInfo;
        const showCost = ref(false);
        const gofinance = () => {
            router.push({
                path: `/finance/overview`
            });
        };
        const sidebar = computed(() => appStore.sidebar);
        const openDoc = () => {
            window.open(process.env.VUE_APP_DOC_URL);
        };
        const unReadCount = ref(0);
        const getUnReadMessageCount = async () => {
            const res = await notReadMessage();
            appStore.setMsgTotal(res.data.total);
            unReadCount.value = res.data.total >= 99 ? "99+" : res.data.total;
        };
        const timer = setInterval(() => {
            if (localStorage.getItem("isRefresh")) {
                getUnReadMessageCount();
                userStore.fetchBalance();
            }
        }, 6000 * 10);
        onMounted(() => {
            userStore.fetchBalance();
            getUnReadMessageCount();
        });
        onUnmounted(() => {
            clearTimeout(timer);
        });
        const showArea = computed(() => {
            return ((activeRouterName.value === "resource" ||
                activeRouterName.value === "application") &&
                !["objectStorageDetail", "cluster-detail"].includes(route.name));
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["navbar", { expand: _unref(sidebar) }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(PageHeader),
                    (_unref(showArea))
                        ? (_openBlock(), _createBlock(Area, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createVNode(CloudNotify, {
                        class: "flex notify",
                        size: "small"
                    }, {
                        icon: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                                "icon-class": "notification",
                                "class-name": "info-icon"
                            })
                        ]),
                        default: _withCtx(() => [
                            _hoisted_2
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_unref(userInfo).type === 'master')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "drop-container",
                            onMouseenter: _cache[0] || (_cache[0] = ($event) => (showCost.value = true)),
                            onMouseleave: _cache[1] || (_cache[1] = ($event) => (showCost.value = false))
                        }, null, 32))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "menu-item",
                        onClick: openDoc
                    }, "帮助文档"),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(CloudInfo, {
                            "un-read-count": unReadCount.value,
                            onReadMessage: getUnReadMessageCount
                        }, null, 8, ["un-read-count"])
                    ]),
                    (_unref(userInfo).type === 'master')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "money-box",
                            onClick: gofinance
                        }, [
                            _hoisted_5,
                            _createElementVNode("span", _hoisted_6, "¥ " + _toDisplayString(_unref(userStore).balance), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
